// src/icons/BatteryLifeIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function BatteryLifeIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 25 24",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M8.25 22C8.0375 22 7.85942 21.9281 7.71575 21.7843C7.57192 21.6406 7.5 21.4625 7.5 21.25V4.35C7.5 4.1375 7.57192 3.95933 7.71575 3.8155C7.85942 3.67183 8.0375 3.6 8.25 3.6H10.5V2.75C10.5 2.5375 10.5719 2.35933 10.7158 2.2155C10.8594 2.07183 11.0375 2 11.25 2H13.75C13.9625 2 14.1407 2.07183 14.2845 2.2155C14.4282 2.35933 14.5 2.5375 14.5 2.75V3.6H16.75C16.9625 3.6 17.1407 3.67183 17.2845 3.8155C17.4282 3.95933 17.5 4.1375 17.5 4.35V21.25C17.5 21.4625 17.4282 21.6406 17.2845 21.7843C17.1407 21.9281 16.9625 22 16.75 22H8.25ZM9 9.5H16V5.1H9V9.5Z",
        fill: "currentColor"
      })
    ]
  });
}
export {
  BatteryLifeIcon
};
//# sourceMappingURL=BatteryLifeIcon.mjs.map